export default (value: any) => {
    switch (String(value)) {
        case "1": return "Amministratore di sistema";
        case "2": return "Amministratore istituto";
        case "3": return "Amministratore azienda";
        case "4": return "Allievo";
        case "5": return "Tutor settore istituto";
        case "6": return "Tutor Articolazione Istituto";
        case "7": return "Tutor settore azienda";
        case "8": return "Referente HR azienda";
        case "9": return "Selezionatore";
        case "10": return "Tutor Formativo istituto";
        case "11": return "Osservatore";
    }
}